import Rest from '../Rest'

/**
 * Privacidade / LGPD — administração.
 *
 * Fila de requisições do titular (Art. 18), histórico de consentimento e log de
 * acesso a dado pessoal. Tudo gateado por `privacy.*`, concedido só ao papel
 * `admin`: requisição de titular é da Hubee, não do clube.
 */
export default class PrivacyService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/privacy'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  dashboard() {
    return this.get('/dashboard')
  }

  requestsGrid(params: any = {}) {
    return this.get('/requests/grid', PrivacyService.clean(params))
  }

  requestDetail(id: number) {
    return this.get(`/requests/${id}`)
  }

  startProcessing(id: number) {
    return this.put(`/requests/${id}/processing`, {})
  }

  complete(id: number, note: string = '') {
    return this.put(`/requests/${id}/complete`, { note })
  }

  reject(id: number, reason: string) {
    return this.put(`/requests/${id}/reject`, { reason })
  }

  consentsGrid(params: any = {}) {
    return this.get('/consents/grid', PrivacyService.clean(params))
  }

  accessLogGrid(params: any = {}) {
    return this.get('/access_logs/grid', PrivacyService.clean(params))
  }

  /** Filtro vazio não pode virar `?status=` — o backend trataria como filtro. */
  private static clean(params: any) {
    return Object.entries(params).reduce((acc: any, [key, value]) => {
      if (value !== null && value !== undefined && value !== '') acc[key] = value
      return acc
    }, {})
  }
}

/**
 * Documentos legais — endpoint **público**, fora do prefixo `/privacy`.
 *
 * Usado no cadastro (para saber a versão vigente que está sendo aceita) e nas
 * páginas de leitura de Termos/Política/Cookies.
 */
export class LegalDocumentService extends Rest {
  static resource = '/api/v1/legal/documents'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  documents() {
    return this.get('')
  }

  document(slug: string) {
    return this.get(`/${slug}`)
  }
}
